import type { ReactNode } from 'react';

export const symbol_speaker_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M260-263h440v-557H260v557Zm220-186q65 0 110-45.24 45-45.23 45-108.76 0-65-45-110.5T480.5-759q-64.5 0-110 45.5t-45.5 110q0 64.5 45.53 109.5T480-449Zm.13-60Q441-509 413-536.61q-28-27.61-28-66.39 0-39.6 27.87-67.8 27.86-28.2 67-28.2Q519-699 547-670.92q28 28.07 28 67.5 0 39.42-27.87 66.92-27.86 27.5-67 27.5Zm.37 182q12.5 0 21-8.63 8.5-8.62 8.5-21.37 0-12-8.62-21-8.63-9-21.38-9-12 0-21 9t-9 21.5q0 12.5 9 21t21.5 8.5ZM344-80q-12.75 0-21.37-8.63Q314-97.25 314-110q0-13 8.5-21.5T344-140h11q31.72 0 55.86-18T445-203H260q-24 0-42-18t-18-42v-557q0-24 18-42t42-18h440q24 0 42 18t18 42v557q0 24-18 42t-42 18H515q10 27 34.14 45T605-140h12q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q629.75-80 617-80H344Zm136-523Z"
		/>
	</svg>
);
